import { OrderReports } from "../components/UI/reusable-components/OrderComponents/OrderReports";

export const OrderReportsPage = () => {
    return (
        <div>
            <OrderReports />
        </div>
    )
}